<template>
  <div class="cservice">
    <div @mouseover="changeIndex(0)"
         @mouseleave="handleMoveLeave()"
         :class="index==0?'cservice-item active':(index!=-1?'cservice-item2':'cservice-item')">
      <div :class="index==0?'bg-img':'bg-img2'"></div>
      <div class="service-content">
        <div class="service-icon" :style="{backgroundImage:'url('+(index==0?'/static/icon_xt.png':'/static/icon_jjfa.png')+')'}" />
        <div class="service-title">解决方案</div>
        <div class="service-desc">
          <div>丰富的行业经验</div>
          <div>10+年的服务经验，给您想要的解决方案</div>
        </div>
        <div :class="index==0?'service-button':'service-button2'" @click="toService()">了解详情</div>
      </div>
    </div>
    <div @mouseover="changeIndex(1)"
         @mouseleave="handleMoveLeave()"
         :class="index==1?'cservice-item active':(index!=-1?'cservice-item2':'cservice-item')">
      <div :class="index==1?'bg-img':'bg-img2'"></div>
      <div class="service-content">
        <div class="service-icon" :style="{backgroundImage:'url('+(index==1?'/static/icon_xt.png':'/static/icon_ffnl.png')+')'}" />
        <div class="service-title">服务能力</div>
        <div class="service-desc">
          <div>一站式服务能力</div>
          <div>更优化的交付质量，更优化</div>
        </div>
        <div :class="index==1?'service-button':'service-button2'" @click="toService()">了解详情</div>
      </div>
    </div>
    <div @mouseover="changeIndex(2)"
         @mouseleave="handleMoveLeave()"
         :class="index==2?'cservice-item active':(index!=-1?'cservice-item2':'cservice-item')">
      <div :class="index==2?'bg-img':'bg-img2'"></div>
      <div class="service-content">
        <div class="service-icon" :style="{backgroundImage:'url('+(index==2?'/static/icon_xt.png':'/static/icon_cczx.png')+')'}" />
        <div class="service-title">产品中心</div>
        <div class="service-desc">
          <div>优质的产品中心</div>
          <div>B2B，B2C等满足您的等满足您的多样需要</div>
        </div>
        <div :class="index==2?'service-button':'service-button2'" @click="toProduction()">了解详情</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "CSevice",
    data() {
      return {
        index: -1
      }
    },
    methods: {
      handleMoveLeave(){
        this.index=-1
      },
      changeIndex(index) {
        this.index = index
      },
      toService(){
        this.$router.push({
          name:'Service'
        })
      },
      toProduction(){
        this.$router.push({
          name:'Production'
        })
      }
    }
  }
</script>

<style scoped>
  .cservice {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 1028px;
    padding-right: 52px;
    margin: 0 auto;
  }

  .cservice-item {
    width: 318px;
    height: 331px;
    background: #FFFFFF;
    box-shadow: 5px 10px 30px 0px rgba(41, 26, 204, 0.12);
    border-radius: 6px;
    margin: 40px 0 90px;
    transition: 0.3s ease-in-out 0s;
    position: relative;
  }

  .cservice-item2 {
    width: 300px;
    height: 331px;
    background: #FFFFFF;
    box-shadow: 5px 10px 30px 0px rgba(41, 26, 204, 0.12);
    border-radius: 6px;
    margin: 40px 0 90px;
    transition: 0.3s ease-in-out 0s;
    position: relative;
  }

  .cservice-item.active {
    width: 354px;
    height: 367px;
    transition: 0.3s ease-in-out 0s;
    margin-top: 22px;
    margin-bottom: 72px;
    box-shadow: 6px 15px 40px 0px rgba(41, 26, 204, 0.12);
    position: relative;
    background-size: cover;
  }

  .bg-img, .bg-img2 {
    background-image: url("../assets/bg2_1.png");
    width: 100%;
    height: 100%;
    transition: 0.3s ease-in-out 0s;
    position: absolute;
    left: 0;
    top: 0;
  }

  .bg-img {
    opacity: 1;
  }

  .bg-img2 {
    opacity: 0;
  }

  .service-content {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;

  }

  .service-icon {
    width: 60px;
    height: 54px;
    margin-top: 43px;
    background-repeat: no-repeat;
    transition: 0.3s ease-in-out 0s;
  }

  .service-title {
    font-size: 22px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #4A4A4A;
    line-height: 29px;
    margin-top: 15px;
    transition: 0.3s ease-in-out 0s;
  }

  .cservice-item.active .service-title, .cservice-item.active .service-desc,.cservice-item.active  .service-button {
    margin-left: 50px;
    color: #ffffff;
  }

  .cservice-item2 .service-title, .cservice-item2 .service-desc,.cservice-item2 .service-button2 {
    margin-left: 28px;
  }

  .cservice-item .service-title, .cservice-item .service-desc,.cservice-item .service-button2 {
    margin-left: 40px;
  }

  .cservice-item.active .service-icon {
    margin-left: 50px;
    color: #ffffff;
    height: 120px;
    width: 71px;
    margin-top: 38px;
  }

  .cservice-item2 .service-icon {
    margin-left: 40px;
  }

  .cservice-item .service-icon {
    margin-left: 55px;
  }

  .service-desc {
    font-size: 13px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #9B9B9B;
    line-height: 22px;
    margin-top: 10px;
    transition: 0.3s ease-in-out 0s;
  }

  .service-button2 {
    width: 99px;
    height: 34px;
    border: 1px solid #291ACC;
    border-radius: 2px;
    text-align: center;
    line-height: 32px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #291ACC!important;
    transition: 0.3s ease-in-out 0s;
    margin-top: 62px;
    cursor: pointer;
  }

  .service-button {
    width: 111px;
    height: 40px;
    background-color: #fff;
    border-radius: 2px;
    text-align: center;
    cursor: pointer;
    line-height: 40px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #291ACC!important;
    transition: 0.3s ease-in-out 0s;
    margin-top: 38px;
  }
</style>



// WEBPACK FOOTER //
// src/components/CSevice.vue